(function () {
  if (window.__dieDeckeVariants) return;
  window.__dieDeckeVariants = true;

  var state = { id: null };

  function read(btn) {
    return {
      id: btn.getAttribute('data-variant-id'),
      raw: parseInt(btn.getAttribute('data-variant-price') || '0', 10),
      price: btn.getAttribute('data-variant-price-formatted') || '',
      compare: btn.getAttribute('data-variant-compare-formatted') || ''
    };
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function fmtNum(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      var value = (num / 100).toFixed(precision);
      var parts = value.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      switch (key) {
        case 'amount': return fmtNum(cents, 2, ',', ',') ;
        case 'amount_no_decimals': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, '.', ',');
      }
    });
  }

  function applyPrices() {
    var qty = getQuantity();
    document.querySelectorAll('[data-price-display]').forEach(function (el) {
      var fmt = el.getAttribute('data-money-format');
      if (fmt) el.textContent = formatMoney((state.raw || 0) * qty, fmt);
      else el.textContent = state.price || '';
    });

    document.querySelectorAll('[data-total-display]').forEach(function (el) {
      var addon = parseInt(el.getAttribute('data-addon') || '0', 10);
      var fmt = el.getAttribute('data-money-format');
      el.textContent = formatMoney((state.raw || 0) * qty + addon, fmt);
    });

    document.querySelectorAll('[data-compare-display]').forEach(function (el) {
      if (state.compare && state.compare !== '') {
        el.textContent = state.compare;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function select(data) {
    if (!data || !data.id) return;
    state.id = data.id;
    state.raw = data.raw || 0;
    state.price = data.price || '';
    state.compare = data.compare || '';

    document.querySelectorAll('[data-variant-id]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-variant-id') === data.id ? 'true' : 'false');
    });

    applyPrices();
  }

  function getQuantity() {
    var input = document.querySelector('[data-qty-input]');
    if (!input) return 1;
    var q = parseInt(input.value, 10);
    return (isNaN(q) || q < 1) ? 1 : q;
  }

  function goToCheckout() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var checkoutUrl = root + 'checkout';
    if (typeof window.ClyroSafeCheckout === 'function') {
      window.ClyroSafeCheckout(null, { getAttribute: function () { return checkoutUrl; } });
      return;
    }
    var inIframe = false;
    try { inIframe = window.top !== window.self; } catch (_) { inIframe = true; }
    if (inIframe || (window.Shopify && Shopify.designMode)) {
      var popup = window.open(checkoutUrl, '_blank', 'noopener');
      if (!popup) window.location.href = checkoutUrl;
      return;
    }
    window.location.href = checkoutUrl;
  }

  function onClick(e) {
    var sizeBtn = e.target.closest('[data-variant-id]');
    if (sizeBtn) {
      if (sizeBtn.disabled || sizeBtn.getAttribute('aria-disabled') === 'true') return;
      select(read(sizeBtn));
      return;
    }

    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var input = (minus || plus).parentNode.querySelector('[data-qty-input]');
      if (input) {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        v = plus ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        applyPrices();
      }
      return;
    }

     var cta = e.target.closest('[data-add-to-cart]');
    if (cta) {
      e.preventDefault();
      if (!state.id || cta._busy) return;
      cta._busy = true;
      var label = cta.textContent;
      cta.textContent = 'Wird hinzugefügt …';

      var resetBtn = function () {
        cta._busy = false;
        cta.textContent = label;
      };

      // Nativen Clyro-Warenkorb-Pfad nutzen: fügt hinzu, lädt den Warenkorb
      // neu (Inhalt + Badge) und slidet den Drawer auf (cart_type = 'drawer').
      if (window.Clyro && Clyro.cart && typeof Clyro.cart.add === 'function') {
        Promise.resolve(Clyro.cart.add(Number(state.id), getQuantity()))
          .then(function (ok) {
            resetBtn();
            if (ok !== false && Clyro.cart && typeof Clyro.cart.open === 'function') {
              Clyro.cart.open();
            }
          })
          .catch(resetBtn);
        return;
      }

      // Fallback (Clyro fehlt): per AJAX hinzufügen, dann Drawer öffnen.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(state.id), quantity: getQuantity() }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          resetBtn();
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(resetBtn);
    }
  }

  function init() {
    var pre = document.querySelector('[data-variant-id][aria-pressed="true"]') ||
              document.querySelector('[data-variant-id]:not([disabled])') ||
              document.querySelector('[data-variant-id]');
    if (pre) select(read(pre));
  }

  document.addEventListener('click', onClick);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();